// extracted by mini-css-extract-plugin
export default {"m":"Footer_m__iru7i","menu":"Footer_menu__Eq6hg","yco":"Footer_yco__fQPFz"};